import { render } from "./Token.vue?vue&type=template&id=2659873a&scoped=true&bindings={\"data\":\"props\",\"changeMessage\":\"setup\",\"validations\":\"setup\",\"checkConfirmField\":\"setup\",\"goConfirm\":\"setup\"}"
import script from "./Token.vue?vue&type=script&lang=ts"
export * from "./Token.vue?vue&type=script&lang=ts"

import "./Token.vue?vue&type=style&index=0&id=2659873a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2659873a"

export default script